<script lang="ts" setup>
import BaseTag from './BaseTag.vue';

defineProps<{
  name?: string;
}>();
</script>

<template>
  <BaseTag bg-pink-500>
    <slot>{{ name }}</slot>
  </BaseTag>
</template>
